import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Box,
  InputBase,
  Paper,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { BellIcon } from "lucide-react";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

interface MyAppBarProps {
  handleDrawerCollapse: () => void;
  drawerOpen: boolean; 
}

const MyAppBar: React.FC<MyAppBarProps> = ({ handleDrawerCollapse, drawerOpen }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [searchText, setSearchText] = React.useState("");

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const navigate = useNavigate();

  const handleMenuClose = () => {
    navigate("/");
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: "rgb(255, 255, 255)",
        color: "rgb(103, 58, 183)",
        boxShadow: "0px 0px 0px",
        paddingX: 1,
        border: "none",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Left Section: App Name + Menu Icon */}

        {/* Center Section: Search Box */}
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "flex-start",
             marginLeft: drawerOpen? 28:8,
          }}
        >
          <Box>
            <IconButton color="inherit" onClick={handleDrawerCollapse}>
              <MenuIcon />
            </IconButton>
          </Box>
          <Paper
            sx={{
              display: "flex",
              alignItems: "center",
              padding: "0 8px",
              width: "30%",
              borderRadius: "20px",
              boxShadow:0,
              marginLeft:2,
              backgroundColor:"#eff2f7",
            }}
          >
            <SearchIcon sx={{ color: "rgba(0, 0, 0, 0.6)" }} />
            <InputBase
              sx={{ marginLeft: 1, flex: 1,}}
              placeholder="Search"
              value={searchText}
              onChange={handleSearchChange}
            />
          </Paper>
        </Box>

        {/* Right Section: Profile Avatar */}
        <Box>
          <IconButton color="inherit">
            <BellIcon />
          </IconButton>

          <IconButton onClick={handleMenuOpen} color="inherit">
            <AccountCircleIcon sx={{fontSize:32}}></AccountCircleIcon>
          </IconButton>

          {/* Profile Dropdown Menu */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
            <MenuItem onClick={handleMenuClose}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default MyAppBar;
